// Generated by purs version 0.13.8
"use strict";
var Affjax = require("../Affjax/index.js");
var Affjax_ResponseFormat = require("../Affjax.ResponseFormat/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HTTP_Method = require("../Data.HTTP.Method/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Bus = require("../Effect.Aff.Bus/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Foreign = require("../Foreign/index.js");
var Lunarbox_Api_Endpoint = require("../Lunarbox.Api.Endpoint/index.js");
var Lunarbox_Api_Request = require("../Lunarbox.Api.Request/index.js");
var Lunarbox_Api_Utils = require("../Lunarbox.Api.Utils/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Capability_Resource_Gist = require("../Lunarbox.Capability.Resource.Gist/index.js");
var Lunarbox_Capability_Resource_Project = require("../Lunarbox.Capability.Resource.Project/index.js");
var Lunarbox_Capability_Resource_Tutorial = require("../Lunarbox.Capability.Resource.Tutorial/index.js");
var Lunarbox_Capability_Resource_User = require("../Lunarbox.Capability.Resource.User/index.js");
var Lunarbox_Config = require("../Lunarbox.Config/index.js");
var Lunarbox_Data_Dataflow_Native_NativeConfig = require("../Lunarbox.Data.Dataflow.Native.NativeConfig/index.js");
var Lunarbox_Data_Dataflow_Native_Prelude = require("../Lunarbox.Data.Dataflow.Native.Prelude/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Save = require("../Lunarbox.Data.Editor.Save/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var Lunarbox_Data_Gist = require("../Lunarbox.Data.Gist/index.js");
var Lunarbox_Data_Profile = require("../Lunarbox.Data.Profile/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Record = require("../Record/index.js");
var Routing_Duplex = require("../Routing.Duplex/index.js");
var AppM = function (x) {
    return x;
};
var runAppM = function (env) {
    return function (v) {
        return Control_Monad_Reader_Trans.runReaderT(v)(env);
    };
};
var monadReaderAppM = Control_Monad_Reader_Trans.monadReaderReaderT(Effect_Aff.monadAff);
var monadEffectAppM = Control_Monad_Reader_Trans.monadEffectReader(Effect_Aff.monadEffectAff);
var monadAskAppM = Control_Monad_Reader_Trans.monadAskReaderT(Effect_Aff.monadAff);
var monadAppM = Control_Monad_Reader_Trans.monadReaderT(Effect_Aff.monadAff);
var monadAffAppM = Effect_Aff_Class.monadAffReader(Effect_Aff_Class.monadAffAff);
var functorAppM = Control_Monad_Reader_Trans.functorReaderT(Effect_Aff.functorAff);
var manageUserAppM = new Lunarbox_Capability_Resource_User.ManageUser(function () {
    return monadAppM;
}, Data_Functor.map(functorAppM)(Data_Either.hush)(Lunarbox_Api_Utils.withBaseUrl(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Profile.decodeJsonUsername)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "username";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "isAdmin";
}))()())())(monadAffAppM)(monadAskAppM)(Lunarbox_Api_Request.profile(monadAffAppM))), Lunarbox_Api_Utils.authenticate(monadAffAppM)(monadAskAppM)(Lunarbox_Api_Request.login(monadAffAppM)), Lunarbox_Api_Utils.authenticate(monadAffAppM)(monadAskAppM)(Lunarbox_Api_Request.register(monadAffAppM)));
var bindAppM = Control_Monad_Reader_Trans.bindReaderT(Effect_Aff.bindAff);
var navigateAppM = new Lunarbox_Capability_Navigate.Navigate(function () {
    return monadAppM;
}, Control_Bind.bind(bindAppM)(Control_Monad_Reader_Class.asks(monadAskAppM)(Data_Lens_Getter.view(Lunarbox_Config["_currentUser"](Data_Lens_Internal_Forget.strongForget))))(function (currentUser) {
    return Control_Bind.bind(bindAppM)(Control_Monad_Reader_Class.asks(monadAskAppM)(Data_Lens_Getter.view(Lunarbox_Config["_userBus"](Data_Lens_Internal_Forget.strongForget))))(function (userBus) {
        return Control_Bind.discard(Control_Bind.discardUnit)(bindAppM)(Data_Functor["void"](functorAppM)(Lunarbox_Api_Utils.mkRawRequest(monadAffAppM)(monadAskAppM)({
            endpoint: Lunarbox_Api_Endpoint.Logout.value,
            method: Lunarbox_Api_Request.Get.value
        })))(function () {
            return Control_Bind.discard(Control_Bind.discardUnit)(bindAppM)(Effect_Class.liftEffect(monadEffectAppM)(Effect_Ref.write(Data_Maybe.Nothing.value)(currentUser)))(function () {
                return Control_Bind.discard(Control_Bind.discardUnit)(bindAppM)(Effect_Aff_Class.liftAff(monadAffAppM)(Effect_Aff_Bus.write(Data_Maybe.Nothing.value)(userBus)))(function () {
                    return Lunarbox_Capability_Navigate.navigate(navigateAppM)(Lunarbox_Data_Route.Home.value);
                });
            });
        });
    });
}), function (path) {
    return Control_Bind.bind(bindAppM)(Control_Monad_Reader_Class.asks(monadAskAppM)(Data_Lens_Getter.view(Lunarbox_Config["_changeRoute"](Data_Lens_Internal_Forget.strongForget))))(function (changeRoute) {
        return Effect_Class.liftEffect(monadEffectAppM)(changeRoute(Foreign.unsafeToForeign({}))(Routing_Duplex.print(Lunarbox_Data_Route.routingCodec)(path)));
    });
});
var applyAppM = Control_Monad_Reader_Trans.applyReaderT(Effect_Aff.applyAff);
var applicativeAppM = Control_Monad_Reader_Trans.applicativeReaderT(Effect_Aff.applicativeAff);
var manageGistsAppM = new Lunarbox_Capability_Resource_Gist.ManageGists(function () {
    return monadAppM;
}, function (id) {
    return Control_Bind.bind(bindAppM)(Effect_Aff_Class.liftAff(monadAffAppM)(Affjax.request({
        method: new Data_Either.Left(Data_HTTP_Method.GET.value),
        url: "https://api.github.com/gists/" + Data_Show.show(Lunarbox_Data_Gist.showGistId)(id),
        headers: Affjax.defaultRequest.headers,
        content: Affjax.defaultRequest.content,
        username: Affjax.defaultRequest.username,
        password: Affjax.defaultRequest.password,
        withCredentials: Affjax.defaultRequest.withCredentials,
        responseFormat: Affjax_ResponseFormat.json
    })))(function (result) {
        return Control_Applicative.pure(applicativeAppM)(Control_Bind.bind(Data_Either.bindEither)(Lunarbox_Api_Request.decodeJsonResponse(result))(Data_Argonaut_Decode_Class.decodeJson(Lunarbox_Data_Gist.decodeJsonGist)));
    });
});
var manageProjectsAppM = new Lunarbox_Capability_Resource_Project.ManageProjects(function () {
    return monadAppM;
}, function (id) {
    return Control_Bind.bind(bindAppM)(Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "id";
    }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "project";
    }))()())())(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.Clone(id),
        method: Lunarbox_Api_Request.Get.value
    }))(function (v) {
        return Control_Applicative.pure(applicativeAppM)(Data_Functor.map(Data_Either.functorEither)(function (v1) {
            return v1.project.id;
        })(v));
    });
}, function (state) {
    var body = Lunarbox_Data_Editor_Save.stateToJson(state);
    return Control_Bind.bind(bindAppM)(Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "id";
    }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "project";
    }))()())())(monadAffAppM)(monadAskAppM)({
        endpoint: Lunarbox_Api_Endpoint.Projects.value,
        method: Lunarbox_Api_Request.Post.create(Data_Maybe.Just.create(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJson)(body)))
    }))(function (v) {
        return Control_Applicative.pure(applicativeAppM)(Data_Functor.map(Data_Either.functorEither)(function (v1) {
            return v1.project.id;
        })(v));
    });
}, function (id) {
    return Data_Functor.map(functorAppM)(Data_Functor["void"](Data_Either.functorEither))(Lunarbox_Api_Utils.mkRawRequest(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.Project(id),
        method: Lunarbox_Api_Request.Delete.value
    }));
}, function (id) {
    return Control_Bind.bind(bindAppM)(Lunarbox_Api_Utils.mkRawRequest(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.Project(id),
        method: Lunarbox_Api_Request.Get.value
    }))(function (response) {
        return Data_Traversable["for"](applicativeAppM)(Data_Either.traversableEither)(Control_Bind.bind(Data_Either.bindEither)(response)(Lunarbox_Data_Editor_Save.jsonToState))(function (project) {
            return Control_Bind.bind(bindAppM)(Control_Monad_Reader_Class.asks(monadAskAppM)(Data_Lens_Getter.view(Lunarbox_Config["_allowedNodes"](Data_Lens_Internal_Forget.strongForget))))(function (allowed) {
                return Control_Applicative.pure(applicativeAppM)(Lunarbox_Data_Editor_State.compile((function () {
                    if (allowed instanceof Data_Maybe.Just) {
                        var nodeSet = Data_Set.fromFoldable(Data_Foldable.foldableArray)(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(allowed.value0);
                        var go = function (v) {
                            return Data_Set.member(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(v.name)(nodeSet);
                        };
                        return Lunarbox_Data_Dataflow_Native_NativeConfig.loadNativeConfigs(Data_Foldable.foldableArray)(Data_Array.filter(go)(Lunarbox_Data_Dataflow_Native_Prelude.configs))(project);
                    };
                    if (allowed instanceof Data_Maybe.Nothing) {
                        return Lunarbox_Data_Dataflow_Native_Prelude.loadPrelude(project);
                    };
                    throw new Error("Failed pattern match at Lunarbox.AppM (line 108, column 19 - line 117, column 51): " + [ allowed.constructor.name ]);
                })()));
            });
        });
    });
}, Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "nodeCount";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "functionCount";
}))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "metadata";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "id";
}))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Tutorial.decodeJsonTutorialId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "own";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "id";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "completed";
}))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "nodeCount";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "functionCount";
}))()())())(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "name";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "metadata";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "id";
}))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "userProjects";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "tutorials";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "exampleProjects";
}))()())())(monadAffAppM)(monadAskAppM)({
    endpoint: Lunarbox_Api_Endpoint.Projects.value,
    method: Lunarbox_Api_Request.Get.value
}), function (id) {
    return function (json) {
        return Data_Functor.map(functorAppM)(Data_Functor["void"](Data_Either.functorEither))(Lunarbox_Api_Utils.mkRawRequest(monadAffAppM)(monadAskAppM)({
            endpoint: new Lunarbox_Api_Endpoint.Project(id),
            method: Lunarbox_Api_Request.Put.create(new Data_Maybe.Just(json))
        }));
    };
});
var manageTutorialsAppM = new Lunarbox_Capability_Resource_Tutorial.ManageTutorials(function () {
    return monadAppM;
}, function (id) {
    return Control_Bind.bind(bindAppM)(Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "message";
    }))()())())(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.CompleteTutorial(id),
        method: Lunarbox_Api_Request.Get.value
    }))(function (v) {
        return Control_Applicative.pure(applicativeAppM)(new Data_Either.Right(Data_Unit.unit));
    });
}, function (projectData) {
    var tutorial = Record.merge()()({
        content: Data_Default.def(Lunarbox_Data_Gist.defaultGistId),
        name: "My tutorial"
    })(projectData);
    return Control_Bind.bind(bindAppM)(Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Tutorial.decodeJsonTutorialId)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "id";
    }))()())())(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "tutorial";
    }))()())())(monadAffAppM)(monadAskAppM)({
        endpoint: Lunarbox_Api_Endpoint.Tutorials.value,
        method: Lunarbox_Api_Request.Post.create(Data_Maybe.Just.create(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_ProjectId.encodeJsonProjectId)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Gist.encodeJsonGistId)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_ProjectId.encodeJsonProjectId)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
            return "solution";
        }))())(new Data_Symbol.IsSymbol(function () {
            return "name";
        }))())(new Data_Symbol.IsSymbol(function () {
            return "content";
        }))())(new Data_Symbol.IsSymbol(function () {
            return "base";
        }))())())(tutorial)))
    }))(function (v) {
        return Control_Applicative.pure(applicativeAppM)(Data_Functor.map(Data_Either.functorEither)(Data_Functor.map(Data_Functor.functorFn)(function (v1) {
            return v1.id;
        })(function (v1) {
            return v1.tutorial;
        }))(v));
    });
}, function (id) {
    return Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeJsonNull)(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.Tutorial(id),
        method: Lunarbox_Api_Request.Delete.value
    });
}, function (id) {
    return Lunarbox_Api_Utils.mkRequest(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_Gist.decodeJsonGistId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Lunarbox_Data_ProjectId.decodeJsonProjectId)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "solution";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "base";
    }))()())())(monadAffAppM)(monadAskAppM)({
        endpoint: new Lunarbox_Api_Endpoint.Tutorial(id),
        method: Lunarbox_Api_Request.Get.value
    });
}, function (id) {
    return function (g) {
        return Data_Functor.map(functorAppM)(Data_Functor.voidRight(Data_Either.functorEither)(Data_Unit.unit))(Lunarbox_Api_Utils.mkRawRequest(monadAffAppM)(monadAskAppM)({
            endpoint: new Lunarbox_Api_Endpoint.Tutorial(id),
            method: Lunarbox_Api_Request.Put.create(Data_Maybe.Just.create(Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeRecord(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_ProjectId.encodeJsonProjectId)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_Gist.encodeJsonGistId)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Encode_Class.gEncodeJsonCons(Lunarbox_Data_ProjectId.encodeJsonProjectId)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(new Data_Symbol.IsSymbol(function () {
                return "solution";
            }))())(new Data_Symbol.IsSymbol(function () {
                return "name";
            }))())(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))())(new Data_Symbol.IsSymbol(function () {
                return "base";
            }))())())(g)))
        }));
    };
});
module.exports = {
    AppM: AppM,
    runAppM: runAppM,
    functorAppM: functorAppM,
    applyAppM: applyAppM,
    applicativeAppM: applicativeAppM,
    bindAppM: bindAppM,
    monadAppM: monadAppM,
    monadEffectAppM: monadEffectAppM,
    monadAffAppM: monadAffAppM,
    monadAskAppM: monadAskAppM,
    monadReaderAppM: monadReaderAppM,
    navigateAppM: navigateAppM,
    manageUserAppM: manageUserAppM,
    manageProjectsAppM: manageProjectsAppM,
    manageTutorialsAppM: manageTutorialsAppM,
    manageGistsAppM: manageGistsAppM
};
